import { AutogenModelEdistatusProfile, AutogenRowEdistatusProfile } from "./autogen/AutogenModelEdistatusProfile";

export class ModelEdistatusProfile extends AutogenModelEdistatusProfile<RowEdistatusProfile> {
	constructor() {
		super(RowEdistatusProfile);
	}
}

export class RowEdistatusProfile extends AutogenRowEdistatusProfile {
}